var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProcessLaunchWrapper',{attrs:{"lastBpmnSrc":"Kundenanschaltung_Provisionierung.bpmn","title":"Provisionierung","description":""}},[_c('ProvisioningProcessStart')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }